<template lang="pug">
    div
        div.dictantFormWrap
            div.formbg
            div.formgradient
                v-img.budLogo(src="images/bud.png")
                div.dictantUserRegister
                    div.formTitle.mb-3 {{ 'DICT_SEARCH' | localize }}
                    v-form.testUserForm(v-on:submit.prevent="userFormSubmit")
                        v-text-field.userFormField(v-model="user.fname" :label="'DICT_FAMIL' | localize" solo flat)
                        v-text-field.userFormField(v-model="user.mname" :label="'DICT_IMYA' | localize" solo flat)
                        v-text-field.userFormField(v-model="user.lname" :label="'DICT_OTCH' | localize" solo flat)
                        //v-text-field.userFormField(v-model="user.city" label="Населенный пункт" solo flat)
                        
                        div.formBtnWrap
                            v-btn.formBtn(type="submit" text color="#fff") {{ 'DICT_NAITY' | localize }}

        v-progress-linear(v-if="loading" :indeterminate="true")
        template(v-if="resultmode != null")
            v-card(flat v-if="resultmode == 0")
                v-card-title {{ 'DICT_SPS_1' | localize }} {{ userdictresult.ball }} {{ 'DICT_SPS_2' | localize }}
                v-card-text
                    div.sertWrap
                        div.taCenter
                            a(:href="pdfPath") {{ 'DICT_SKACHAT' | localize }}
                        div.sert
                            pdf(:src="pdfPath")

            v-card(flat v-else-if="resultmode == 1")
                v-card-title {{ 'DICT_RES_MORE' | localize }}

                v-card-text
                    div(v-for="res in dictresults" :key="res.id") 
                        a(@click="selectResult(res)") {{ res.fname }} {{ res.mname }} {{ res.lname }} {{ res.city && res.city!='' ? ' ,'+res.city : '' }}

            //v-card(flat v-else-if="resultmode == 2")
                v-card-title {{ 'DICT_NO_RES' | localize }}

                v-card-text
                    div.mb-5
                        a(href="/res/Неидентифицированные участники.xls") Список участников без фамилий
                    div {{ 'DICT_Q_1' | localize }}
                        router-link(to="/page/contacts") {{ 'DICT_Q_2' | localize }}.
</template>


<script>
    import { dictresultService } from '@/_services'
    import { config } from '@/_helpers'
    import pdf from 'vue-pdf'

    export default {
        components: {
            pdf
        },
        mounted () {
            
        },
        computed: {
            
        },
        methods: {
            validateUserForm(){
                this.$v.$touch()
                let isInvalid = this.$v.$invalid
                return isInvalid
            },
            userFormSubmit(){
                this.resultmode = null
                this.userdictresult = null
                this.dictresults = null
                this.pdfPath = null
                if (this.user.fname != '' || this.user.mname != '' || this.user.lname != '' || this.user.city != ''){
                    this.loading = true
                    dictresultService.searchResult(this.user).then(data => {
                        this.resultmode = data.mode
                        if (data.mode == 0) {
                            this.userdictresult = data.dictantResult
                            this.pdfPath = config.apiUrl+'dictant/getsertificat/'+this.userdictresult.id
                        } else {
                            this.dictresults = data.dictantResultList
                        }
                        this.loading = false
                    })
                }
            },
            selectResult(res){
                this.userdictresult = res
                this.resultmode = 0
                this.pdfPath = config.apiUrl+'dictant/getsertificat/'+this.userdictresult.id
            }
        },
        watch: {
            
        },
        data() {
            return {
                user:{
                    mname:'',
                    fname:'',
                    lname:'',
                    city:''
                },
                loading:false,
                resultmode:null,
                dictresults:null,
                pdfPath:null,
                userdictresult:null
            }
        }
    }
</script>

<style lang="scss" scoped>
    .taCenter {text-align: center;}
    .pd-5{
        padding:5px
    }
    .dictantFormWrap {
        width:100%;
        height: 540px;
        position: relative;
        font-family: Segoe UI;
    }
    .formbg {
        background: url(/images/dictant.jpg) no-repeat center;
        background-size: cover;
        height: 100%;
    }
    .formgradient{
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background:linear-gradient(180deg, rgba(183, 7, 7, 0.15) 99.99%, rgba(255, 255, 255, 0) 100%)
    }
    .budLogo {
        width:35%;
        height:auto;
        margin: 3% 0 0 8%;
    }
    .dictantUserRegister {
        margin:4% 0 0 8%;
        color:#fff;
        width:280px;
    }
    .userFormField {
        font-family: Segoe UI;
        font-style: italic;
    }
    .formBtnWrap {
        position: relative;
    }
    .formBtn {
        background:#FF4646;
        font-family: Segoe UI;
        font-style: italic;
        text-transform: none;
        position: absolute;
        right: 0;
    }
    .answered.correct {
        background: #0f0;
    }
    .answered.incorrect {
        background: #f00;
    }
    .bordered {
        border:1px solid #f0f0f0;
        background: #0ff;
    }
    .noBreakWords {
        word-break: normal !important;
    }
    .mainTitle {
        font-weight: 300;
        font-size: 18px;
    }
    .cardHead {
        font-weight: 300;
        font-size: 23px;
        font-family: Times New Roman !important;
    }
    .borderOne {
        border-radius: 1px !important;
    }
    .testBtn {
        border-radius: 1px !important;
    }
    .sertWrap {
        width:90%;
        max-width:1000px;
        margin: 10px auto;
    }
    .sert {border:3px solid #c0c0c0;}
    @media (min-width:600px) {
        .dictantFormWrap {
            height:570px;
        }
        .budLogo {
            width:20%;
            margin: 4% 0 0 8%;
        }
    }
    @media (min-width:960px) {
        .dictantFormWrap {
            height:600px;
        }
        .budLogo {
            width:20%;
            margin: 4% 0 0 8%;
        }
    }
    @media (min-width:1264px) {
        .dictantFormWrap {
            height:656px;
        }
        .budLogo {
            width:14%;
            margin: 4% 0 0 8%;
        }
    }
    @media (min-width:1904px) {
        .dictantFormWrap {
            height:656px;
        }
        .budLogo {
            width:14%;
            margin: 4% 0 0 8%;
        }
    }
</style>